import * as api from '../../api/api-descarga-analytic'
import {  GET_INFO_ANALYTIC_PREVIO, SET_INFO_ANALYTIC, SET_LOADING_TRUE, SET_LOADING_FALSE } from '../types'

export const getInfoAnalyticPrevio = () => ({
  type: GET_INFO_ANALYTIC_PREVIO,
  payload: api.serviceGetInformeAnalytic()
})

export const setInfoAnalyticPrevio = (data) => ({
  type: SET_INFO_ANALYTIC,
  payload: data
})

export const setLoadingTrue = () => ({
  type: SET_LOADING_TRUE,
});

export const setLoadingFalse = () => ({
  type: SET_LOADING_FALSE,
});
